<script setup lang="ts">
import BaseIcon from "../../icons/BaseIcon.vue";
</script>

<template>
  <div class="empty-result-view__container">
    <BaseIcon
      name="heroicons:face-frown"
      class="empty-result-view__sad-icon"
      aria-hidden="true"
    />
    <p class="empty-result-view__no-results-text">No results found</p>
    <p class="empty-result-view__extra-info-text">
      We couldn’t find anything with that term. Please try again.
    </p>
  </div>
</template>

<style scoped lang="postcss">
.empty-result-view {
  &__container {
    @apply border-t border-gray-100 py-14 px-6 text-center text-sm sm:px-14;
  }

  &__sad-icon {
    @apply mx-auto h-6 w-6 text-gray-400;
  }

  &__no-results-text {
    @apply mt-4 font-semibold text-gray-900;
  }

  &__extra-info-text {
    @apply mt-2 text-gray-500;
  }
}
</style>
